// Module
var code = "<h1 id=\"info-hub\">Info Hub</h1> <p>This is where users can add and store important information users need access to. These files and folders can be created and view permission be set. The view permission determines who can view the folder and the files/documents in it.</p> <p>The Info Hub can be viewed as a Wiki and/or FAQ section.</p> ";
// Exports
module.exports = code;